import React from 'react';

export const withInputClassNames = Input => props => (
  <Input {...props} oldStyle={false} />
);



// WEBPACK FOOTER //
// ./src/components/PasswordForgot/HOC/index.js